import { createFileRoute } from '@tanstack/react-router'
import { AdminOpsPage } from '@/features/ops/pages/admin-ops-page'

export const Route = createFileRoute('/ops')({
  staticData: { title: 'Break-glass' },
  component: AdminOpsPage,
})
